/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBINFOS, GETBANKINFO, UPDATE_UNIONPAY_INFO } from './constants'

const initState = {
  unionPayInfo: null
}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBINFOS:
      return Object.assign({}, state, { clubInfos: action.payload })
    case GETBANKINFO:
      return Object.assign({}, state, { bankInfo: action.payload })
    case UPDATE_UNIONPAY_INFO:
      return Object.assign({}, state, { unionPayInfo: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubInfo/reduce.js